<template>
  <div class="customer-service-pop">
    <!-- <div class="bg-icon" /> -->
    <div class="title-bg">
      <div class="first_title">{{ $t('contact.lxkf06') }}</div>
      <div class="second_title">{{ $t('contact.lxkf07') }}</div>
    </div>
    <div class="list">
      <div class="item">
        <div class="left">
          <div class="icon2" />
          <div>{{ $t('contact.lxkf02') }}</div>
        </div>
        <div class="right" @click="openNew(telgramurl)">{{ $t('contact.lxkf04') }}
        </div>
      </div>
      <div v-if="onlineurl" class="item">
        <div class="left">
          <div class="icon1" />
          <div>{{ $t('contact.lxkf01') }}</div>
        </div>
        <div class="right" @click="openNew(onlineurl)">{{ $t('contact.lxkf04') }}
        </div>
      </div>
      <div class="item">
        <div class="left">
          <div class="icon2" />
          <div>{{ $t('contact.lxkf05') }}</div>
        </div>
        <div class="right" @click="openNew(viptelurl)">{{ $t('contact.lxkf04') }}
        </div>
      </div>
      <div class="item">
        <div class="left">
          <div class="icon3" />
          <div>{{ $t('contact.lxkf03') }}</div>
        </div>
        <div class="right" @click="openNew(officialurl)">{{ $t('contact.lxkf04') }}
        </div>
      </div>
      <!-- <div class="item">
        <div class="left">
          <div class="icon4" />
          <div>WhatsApp</div>
        </div>
        <div class="right" @click="openNew(whatsappurl)">{{ $t('contact.lxkf04') }}
        </div>
      </div> -->
    </div>
    <div class="close-icon" name="cross" @click="$emit('close')" />
  </div>
</template>
<script>
import { getServerUrl } from '@/api/user'
export default {
  props: {
    isRoute: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      telgramurl: '',
      officialurl: '',
      onlineurl: '',
      whatsappurl: '',
      viptelurl: ''
    }
  },
  async created() {
    const res = await getServerUrl({ isRoute: this.isRoute })
    this.telgramurl = res.telgramurl
    this.officialurl = res.officialurl
    this.onlineurl = res.onlineurl
    this.whatsappurl = res.whatsappurl
    this.viptelurl = res.viptelurl
  },
  methods: {
    openNew(url) {
      window.open(url)
    }
  }
}
</script>
<style lang="less" >
.customer-service-pop{
    height: 688px;
    width: 574px;
    padding-bottom: 10px;
    // background: #202a41;
    // background: var(--service-pop-bg);
    // background-size: 100% 100%;
    // border-radius: 28px;
    display: flex;
    flex-direction: column;
    .title-bg{
      background: var(--customer-service-bg);
      background-size: 100% 100%;
      width: 608px;
      min-height: 368px;
      margin-left:12px;
    }
    .first_title{
      font-family: AlibabaPuHuiTi_3_105_Heavy;
      font-size: 36px;
      // color: #F6F1FF;
      line-height: 52px;
      font-weight: 900;
      margin: 88px 0 0 24px;
      display: inline-block;
      background-image: var(--high-color-text);
      -webkit-background-clip: text;
      color: transparent;
      background-clip: text;
    }
    .second_title{
      font-family: AlibabaPuHuiTi_3_55_Regular;
      font-size: 32px;
      color: #F6F1FF;
      line-height: 48px;
      font-weight: 400;
      margin: 0 0 0 24px;
    }
    .close-icon{
        position: absolute;
        // top: 24px;
        // right: 24px;
        bottom: -92px;
        left: calc(50% - 26px);
        z-index: 9;
        height: 52px;
        width:52px;
        background: url(~@/assets/portal/auth/icon_close.svg);
        background-size: 100% 100%;
    }
    .bg-icon {
        position: absolute;
        top: 0;
        right: 20px;
        width: 680px;
        height: 560px;
        background: url(~@/assets/portal/customerService/customer_service_bg.png) no-repeat 50%;
        background-size: 100% 100%;
        z-index: 2;
    }
    .icon {
        height: 360px;
    }
    .list {
        position: relative;
        // width: 450px;
        z-index: 99;
        // top: 500px;
        margin-top: -160px;
        border-radius: 40px;
        background: rgba(225,190,231,0.08);
        // background:rgba(231, 221, 190,0.08);
        // background-image: radial-gradient(circle at 2.9% 0%, rgba(144,38,255,0.20) 0%, rgba(145,44,250,0.00) 40%);
        border-width: 0.5px;
        border-style: solid;
        border-color: rgba(255,255,255,0.30);
        // box-shadow: inset 0 0 8px 0 rgba(255,255,255,0.10);
        padding: 24px 48px;
        backdrop-filter: blur(20px);
        .item {
            margin-top: 16px;
            // padding: 0 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 482px;
            height: 96px;
            // background: var(--service-pop-border);
            // background-size: 100% 100%;
            .left {
                display: flex;
                align-items: center;
                font-family: PingFangSC-Regular;
                font-size: 28px;
                color: #F6F1FF;
                font-weight: 400;
                .icon1 {
                    margin: 16px 16px 16px 0px;
                    width: 64px;
                    height: 64px;
                    background: url(~@/assets/portal/auth/在线客服.webp) no-repeat 50%;
                    background-size: 100% 100%;
                }
                .icon2 {
                  margin: 16px 16px 16px 0px;
                    width: 64px;
                    height: 64px;
                    background: url(~@/assets/portal/auth/TG客服.webp) no-repeat 50%;
                    background-size: 100% 100%;
                }
                .icon3 {
                  margin: 16px 16px 16px 0px;
                    width: 64px;
                    height: 64px;
                    background: url(~@/assets/portal/auth/官方频道.webp) no-repeat 50%;
                    background-size: 100% 100%;
                }
                .icon4 {
                    margin-right: 20px;
                    width: 40px;
                    height: 42px;
                    background: url(~@/assets/portal/customerService/WhatsAPP.png) no-repeat 50%;
                    background-size: 100% 100%;
                }
            }
            .right {
                height: 48px;
                width: 160px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: var(--button-service-popup-consult);
                border-radius: 48px;
                font-family: PingFangSC-Medium;
                font-size: 24px;
                color: var(--btn-text-color);
                // border-color:var(--btn-bg-border-color);
                // box-shadow: var(--btn-bg-box-shadow);
                // border-width: 1px;
                // border-style: solid;
                text-align: center;
                line-height: 48px;
                font-weight: 500;
                // margin-right:24px;
                .btn_jinru {
                    margin-left: 20px;
                    width: 14px;
                    height: 20px;
                    background: url(~@/assets/portal/customerService/btn_jinru2.png) no-repeat 50%;
                    background-size: 100% 100%;
                }
            }
        }
        .item:last-child{
          border-bottom: none;
        }
    }
}
.van-popup {
    overflow-y: initial;
    background-color: transparent;
}
</style>
